import { SvgIcon, SvgIconProps } from '@mui/material';

const MonitorIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || '1em'}
    height={props.height || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_4126_20616"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="currentColor" />
    </mask>
    <g mask="url(#mask0_4126_20616)">
      <path
        d="M2.5 10.25V7.30775C2.5 6.80258 2.675 6.375 3.025 6.025C3.375 5.675 3.80258 5.5 4.30775 5.5H19.6923C20.1974 5.5 20.625 5.675 20.975 6.025C21.325 6.375 21.5 6.80258 21.5 7.30775V10.25H20V7.30775C20 7.23075 19.9679 7.16025 19.9038 7.09625C19.8398 7.03208 19.7693 7 19.6923 7H4.30775C4.23075 7 4.16025 7.03208 4.09625 7.09625C4.03208 7.16025 4 7.23075 4 7.30775V10.25H2.5ZM4.30775 20.5C3.80258 20.5 3.375 20.325 3.025 19.975C2.675 19.625 2.5 19.1974 2.5 18.6923V15.75H4V18.6923C4 18.7692 4.03208 18.8398 4.09625 18.9038C4.16025 18.9679 4.23075 19 4.30775 19H19.6923C19.7693 19 19.8398 18.9679 19.9038 18.9038C19.9679 18.8398 20 18.7692 20 18.6923V15.75H21.5V18.6923C21.5 19.1974 21.325 19.625 20.975 19.975C20.625 20.325 20.1974 20.5 19.6923 20.5H4.30775ZM10 17.75C10.1385 17.75 10.2702 17.7154 10.3952 17.6463C10.5203 17.5769 10.6147 17.473 10.6788 17.3345L14 10.6923L15.3212 13.3345C15.3853 13.473 15.4798 13.5769 15.6048 13.6463C15.7298 13.7154 15.8615 13.75 16 13.75H21.5V12.25H16.4712L14.6788 8.6655C14.6148 8.53333 14.5218 8.43942 14.4 8.38375C14.2782 8.32792 14.1448 8.3 14 8.3C13.8615 8.3 13.7298 8.32792 13.6048 8.38375C13.4798 8.43942 13.3853 8.53333 13.3212 8.6655L10 15.3077L8.67875 12.6655C8.61475 12.527 8.52025 12.4231 8.39525 12.3537C8.27025 12.2846 8.1385 12.25 8 12.25H2.5V13.75H7.52875L9.32125 17.3345C9.38525 17.473 9.47975 17.5769 9.60475 17.6463C9.72975 17.7154 9.8615 17.75 10 17.75Z"
        fill="currentColor"
      />
      <rect x="4" y="3.5" width="7" height="3" rx="0.5" fill="currentColor" />
      <rect x="13" y="3.5" width="7" height="3" rx="0.5" fill="currentColor" />
    </g>
  </SvgIcon>
);

export default MonitorIcon;
